/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemoModeToggleResponse
 */
export interface DemoModeToggleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DemoModeToggleResponse
     */
    isDemo: boolean;
}

/**
 * Check if a given object implements the DemoModeToggleResponse interface.
 */
export function instanceOfDemoModeToggleResponse(value: object): value is DemoModeToggleResponse {
    if (!('isDemo' in value) || value['isDemo'] === undefined) return false;
    return true;
}

export function DemoModeToggleResponseFromJSON(json: any): DemoModeToggleResponse {
    return DemoModeToggleResponseFromJSONTyped(json, false);
}

export function DemoModeToggleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoModeToggleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isDemo': json['is_demo'],
    };
}

  export function DemoModeToggleResponseToJSON(json: any): DemoModeToggleResponse {
      return DemoModeToggleResponseToJSONTyped(json, false);
  }

  export function DemoModeToggleResponseToJSONTyped(value?: DemoModeToggleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_demo': value['isDemo'],
    };
}

